import * as React from "react";

const ArrowLeft: React.FC = () => {
    return (
        <svg
            id="Component_1_23"
            data-name="Component 1 – 23"
            xmlns="http://www.w3.org/2000/svg"
            width="50"
            height="50"
            viewBox="0 0 50 50"
        >
            <g id="Ellipse_2" data-name="Ellipse 2" fill="#fff" stroke="#e5e5e5" stroke-width="2">
                <circle cx="25" cy="25" r="25" stroke="none" />
                <circle cx="25" cy="25" r="24" fill="none" />
            </g>
            <path
                id="Path_6"
                data-name="Path 6"
                d="M-316.811,568.929V556.775h12.154"
                transform="translate(-150.538 -591.624) rotate(-45)"
                fill="none"
                stroke="#d14124"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="3"
            />
        </svg>
    );
};

export default React.memo(ArrowLeft);
